import { css } from '@/styled-system/css';

export const triggerButtonStyles = css.raw({
  'display': 'inline-flex',
  'borderRadius': 'TriggerButton',
  'position': 'relative',
  'verticalAlign': 'top',
  'cursor': 'pointer',

  '_after': {
    content: '""',
    cursor: 'inherit',
    position: 'absolute',
    inset: '-5px',
  },

  '_focusVisible': {
    boxShadow: 'focus',
  },

  '& > [data-c11n-component="Icon"] > .help-circle': {
    fill: 'TriggerButton.bg.default',
    stroke: 'TriggerButton.border.default',
  },

  '& > [data-c11n-component="Icon"] > .help-question-mark': {
    fill: 'TriggerButton.text',
  },

  '_hover': {
    '& > [data-c11n-component="Icon"] > .help-circle': {
      fill: 'TriggerButton.bg.hover',
    },
  },

  '_active': {
    '& > [data-c11n-component="Icon"] > .help-circle': {
      fill: 'TriggerButton.bg.pressed',
      stroke: 'TriggerButton.border.pressed',
    },
  },
});
